module.exports = __webpack_public_path__ + "img/zeus_symbol.2d1dc531.svg";